import { H } from 'components';
import { useReducer } from 'react';
import { AddTaskP01, TaskListP01 } from '../IntendendComponents';

const tasksReducer = (tasks, action) => {
  switch (action.type) {
    case 'added': {
      return [
        ...tasks,
        {
          id: action.id,
          text: action.text,
          done: false,
        },
      ];
    }
    case 'changed': {
      return tasks.map(t => {
        if (t.id === action.task.id) {
          return action.task;
        } else {
          return t;
        }
      });
    }
    case 'deleted': {
      return tasks.filter(t => t.id !== action.id);
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
};

let nextId = 3;
const initialTasks = [
  { id: 0, text: 'Philosopher’s path', done: true },
  { id: 1, text: 'Visit the temple', done: false },
  { id: 2, text: 'Drink matcha', done: false },
];

const Prac10 = () => {
  const [tasks, dispatch] = useReducer(tasksReducer, initialTasks);

  const handleAddTask = text => {
    dispatch({ type: 'added', id: nextId++, text: text });
  };

  const handleChangeTask = task => {
    dispatch({ type: 'changed', task: task });
  };

  const handleDeleteTask = taskId => {
    dispatch({ type: 'deleted', id: taskId });
  };

  return (
    <>
      <H level={3}>Day off in Kyoto</H>
      <AddTaskP01 onAddTask={handleAddTask} />
      <TaskListP01
        tasks={tasks}
        onChangeTask={handleChangeTask}
        onDeleteTask={handleDeleteTask}
      />
    </>
  );
};

export default Prac10;
